export default __webpack_public_path__ + "static/media/image-chairsensor-w.eb08d395.png";